import { render, staticRenderFns } from "./CompanyProfileFeedSection.vue?vue&type=template&id=097bdf36&scoped=true"
import script from "./CompanyProfileFeedSection.vue?vue&type=script&lang=js"
export * from "./CompanyProfileFeedSection.vue?vue&type=script&lang=js"
import style0 from "./CompanyProfileFeedSection.vue?vue&type=style&index=0&id=097bdf36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "097bdf36",
  null
  
)

export default component.exports